import React from 'react';
// import $ from 'jquery';
import charming from 'charming';
import imagesLoaded from 'imagesloaded';
import { TimelineMax, TweenMax, Quart, Quint, Expo } from 'gsap';
import '../../layouts/sub.scss';

class MemberSlider extends React.Component {
  componentDidMount() {}
  render() {
    return (
      <>
        <div>aaa</div>
      </>
    );
  }
}

export default MemberSlider;
